'use client';

import { useTranslations } from 'next-intl';
import { useConsentRuntime } from './ConsentRuntime';
import styles from 'components/shared/Footer/index.module.css';

export function PrivacyChoicesButton() {
  const t = useTranslations('common');
  const { stack, openPrivacyChoices } = useConsentRuntime();
  if (stack !== 'next') return null;

  return (
    <button
      type="button"
      className={`${styles.styledLink} ${styles.privacyChoicesButton}`}
      onClick={openPrivacyChoices}
    >
      {t('cookieBanner.privacyChoices')}
    </button>
  );
}
